export default function () {
    const $parent = $('.module-onpage');

    if (!$parent.length) {
        return;
    }

    const $window = $(window);
    const $body = $('body');
    const $taglines = $('.onpage-eligible .tagline');
    const $onPageNaviFull = $('.module-onpage--fullwidth');
    const $mobileheader = $parent.find('.onpage-mobileheader');
    const $closeIcon = $parent.find('.mobile-close');
    const $navigation = $parent.find('.onpage-nav');
    const $navigationList = $('#onpagemenu > .nav');
    const $initialHeadline = $parent.find('.current-headline').html();
    const $currentHeadline = $parent.find('.current-headline');
    let pageNavItemClicked = false;
    // scroll arrows for onpagenavi fullwidth
    const scrollUnit = 150;
    const $onpageMenu = $('#onpagemenu');
    const $scrollLeft = $('.scroll.left');
    const $scrollRight = $('.scroll.right');

    function replaceHeadlineWithInitialHeadlineIfNeeded() {
        const $activeMenuItems = $navigation.find('.active').length;

        if ($activeMenuItems <= 0) {
            $currentHeadline.html($initialHeadline);
            $mobileheader.css('color', '#000000');
        }
    }

    function widthOfList() {
        let itemsWidth = 0;
        $navigationList.find('li').each(function eachHandler() {
            itemsWidth += $(this).outerWidth();
        });
        return itemsWidth;
    }

    function reAdjust() {
        if ($navigationList.position() && $navigationList.position().left < 0) {
            $scrollLeft.show();
            $navigation.addClass('fadeText');
        } else {
            $scrollLeft.hide();
            $navigation.removeClass('fadeText');
        }

        let rightOffset = 0;
        if ($navigationList.position()) {
            rightOffset = (widthOfList() - $onpageMenu.outerWidth()) + $navigationList.position().left;
        }
        if (rightOffset > 0) {
            $scrollRight.show();
        } else {
            $scrollRight.hide();
        }
    }

    function slideOnpage() {
        setTimeout(() => {
            const iAmActive = $navigationList.find('.active');
            const maxListWidt = $navigationList.outerWidth() - widthOfList();
            let positionLeft = iAmActive.position().left - 10;
            const lastItemWidth = $navigationList.find('li').last().outerWidth();

            if (-positionLeft < maxListWidt) {
                positionLeft = -maxListWidt + (lastItemWidth / 2);
            }

            $navigationList.animate({ left: `-${positionLeft}px` }, 'slow', () => {
                reAdjust();
            });
        }, 300);
    }

    // build menu
    $taglines.each(function eachHandler() {
        const $item = $(this);
        // for each tagline, find the id of the element it belongs to
        const parentId = $item.closest('.frame').attr('id');
        const $menuItem = `<li><a href="#${parentId}">${$item.text()}</a></li>`;
        $navigationList.append($menuItem);
    });

    // init scrollspy
    $('.body').scrollspy({
        target: '#onpagemenu',
    });

    // detect active element bootstrap is so nice dude
    $('#onpagemenu').on('activate.bs.scrollspy', () => {
        const $activeHeadline = $navigation.find('.active a').html();
        // on mobile: replace navigation headline with title of active menu-item
        $currentHeadline.html($activeHeadline);
        $mobileheader.css('color', '#2190da');

        if (!pageNavItemClicked) {
            slideOnpage();
        }
    });

    // if no menu-item is active, use the regular headline
    window.addEventListener('scroll', replaceHeadlineWithInitialHeadlineIfNeeded, { passive: true });
    window.addEventListener('resize', replaceHeadlineWithInitialHeadlineIfNeeded, { passive: true });
    window.addEventListener('orientationchange', replaceHeadlineWithInitialHeadlineIfNeeded, { passive: true });

    // open and close navigation on mobile
    $mobileheader.on('click', () => {
        $navigation.show().css('z-index', '200');
        $body.addClass('dim-it');

        // this close-button is only visible inside the opened navigation on mobile
        $closeIcon.on('click', () => {
            $navigation.hide().css('z-index', 'initial');
            $body.removeClass('dim-it');
        });
    });

    const speed = 800;

    // smooth scrolling
    $navigationList.find('a').on('click', (e) => {
        // e.preventDefault();
        const href = $(e.target).attr('href');

        pageNavItemClicked = true;
        $window.trigger('onpagenav-item-clicked');

        if (window.innerWidth > 1023 && $('.layout_2columns_8-4').length) {
            $('html, body').animate({
                scrollTop: $(href).offset().top,
            }, speed, null, () => {
                setTimeout(() => {
                    $window.trigger('scroll-end');
                }, speed);

                // close onpagenav menu
                if (window.innerWidth < 1024) {
                    $navigation.hide();
                }
            });
        } else {
            let onpageHeight = 0;
            if (window.innerWidth > 1023) {
                onpageHeight = $('.module-onpage').outerHeight();
            } else {
                onpageHeight = $('.onpage-mobileheader').outerHeight() - $('.tagline').outerHeight();
            }

            $('html, body').animate({
                scrollTop: $(href).offset().top - onpageHeight,
            }, speed).promise().then(() => {
                setTimeout(() => {
                    $window.trigger('scroll-end');
                }, speed);

                // close onpagenav menu
                if (window.innerWidth < 1024) {
                    $navigation.hide();
                }
            });
        }
    });

    // only for onpage navi fullwidth

    let scrolling = false;
    $window.scroll(() => {
        scrolling = true;
    });

    // we need the time to set the offset of the onpagenavi because some stylings
    // and functions are not ready, otherwise we have a wrong calculation
    setTimeout(() => {
        const $onPageNaviFullOffset = $onPageNaviFull.offset();
        setInterval(() => {
            if (scrolling) {
                scrolling = false;

                if (window.innerWidth > 1023 && $onPageNaviFull.length) {
                    if ($window.scrollTop() > $onPageNaviFullOffset.top) {
                        $onPageNaviFull.addClass('sticky');
                    } else {
                        $onPageNaviFull.removeClass('sticky');
                    }
                }
            }
        }, 200);
    }, 200);

    $scrollLeft.on('click', (e) => {
        e.preventDefault();
        if ($navigationList.position().left <= -scrollUnit) {
            $navigationList.animate({ left: `+=${scrollUnit}px` }, 'slow', () => {
                reAdjust();
            });
        } else {
            $navigationList.animate({ left: 0 }, 'slow', () => {
                reAdjust();
            });
        }
    });

    $scrollRight.on('click', (e) => {
        e.preventDefault();
        if ($navigationList.position().left >= $onpageMenu.outerWidth() - widthOfList()) {
            $navigationList.animate({ left: `-=${scrollUnit}px` }, 'slow', () => {
                reAdjust();
            });
        }
    });

    window.addEventListener('scroll-end', () => {
        slideOnpage();
        pageNavItemClicked = false;
    }, { passive: true });
}
